module.exports = "/images/Bling_v2.png?e1bd5bb5924cb1de89b2f99d1b22fbbe";